// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list_2zt0b","listItem":"List_listItem_3dEBv","department":"List_department_2hJvA","departmentWorkers":"List_departmentWorkers_1f2f3"};